import { handleApiResponse, notify } from '@/functions';
import { useMutation } from '@tanstack/react-query';
import { useInvalidateQueries } from '@/hooks';
import { apiClient } from '@/components/api';
import routes from '@/lib/routes';

export const useRequestDeletePaymentOperator = () => {

  const { invalidate } = useInvalidateQueries();
  const { isPending, error, mutateAsync } = useMutation({
    mutationKey: [routes.api.paymentProviders, 'delete'],
    mutationFn: (operatorKey: string) =>
      apiClient
        .delete(routes.api.deletePaymentOperator(operatorKey))
        .then(handleApiResponse)
        .catch(error => {
          notify(error?.internalMessage, 'error');
          throw error;
        }),
    onSuccess: () => {
      invalidate(routes.api.paymentProviders);
      notify('Opérateur supprimé', 'success');
    }
  });

  return ({
    isLoadingDeletePaymentOperator: isPending,
    triggerDeletePaymentOperator: (operatorKey: string) => mutateAsync(operatorKey),
    error
  });

};
